import { render } from "./messengerDetailChat.vue?vue&type=template&id=3df11d15&scoped=true"
import script from "./messengerDetailChat.vue?vue&type=script&lang=js"
export * from "./messengerDetailChat.vue?vue&type=script&lang=js"

import "./messengerDetailChat.vue?vue&type=style&index=0&id=3df11d15&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3df11d15"]])

export default __exports__